export interface DrawerFilter {
  type: DrawerFilterType;
  label: string;
  value?: string;
  name: string;
  list?: { value: string; text: string }[];
}

export interface DrawerSort {
  name: string;
  value: string;
}

export enum DrawerFilterType {
  SELECT = 'SELECT',
  INPUT = 'INPUT',
  DATE = 'DATE',
}
